import { DevicePid, KK } from '@/define/define'
import list_icon from '@/assets/img/device/mg75/list_icon.png'
import { getDeviceKeySquare } from '../keysquare/keysquare'
import { BaseDevice, CustomLayout } from '@/profiles/base_device'
import { LIGHT_EFFECT_LIST_HuoChaiRen } from '../../light/light_effect_list'
import { polar75VKCodes } from '../keycode/vkeycode'
import { generateArray } from '@/tool/utility'

export class MG75V2C12 extends BaseDevice {
  name: string = 'MG75V2'
  icon: string = list_icon
  width: number = 614
  square = getDeviceKeySquare(DevicePid.IROKMG75V2C12)
  y_number: number = 10
  lightEffectList = LIGHT_EFFECT_LIST_HuoChaiRen

  vkcodes = polar75VKCodes

  inoperableKeys: KK[] = [0xff]
  fnFactoryKeys: KK[] = [0x3a, 0x3b, 0x3c, 0x3d, 0x3e, 0x3f, 0x40, 0x41, 0x42, 0x43, 0x44, 0x45, 0x4c, 0x4b, 0x4e, 0x52, 0x51, 0x50, 0x4f, 0x16, 0x1b, 0xe3, 0x04]
  customLayout: CustomLayout = {
    0x3a: this.createSquare(12),

    0x3e: this.createSquare(10),
    0x42: this.createSquare(10),

    0x46: this.createSquare(12),

    0x2a: this.createSquare(2, 2, 76),
    0x2b: this.createSquare(2, 2, 58),
    0x31: this.createSquare(2, 2, 57),
    0x39: this.createSquare(2, 2, 67),
    0x28: this.createSquare(2, 2, 90),
    0xe1: this.createSquare(2, 2, 94),
    0xe0: this.createSquare(2, 2, 50),
    0xe2: this.createSquare(2, 2, 50),
    0xe3: this.createSquare(2, 2, 50),
    0xe5: this.createSquare(2, 2, 64),
    0x2c: this.createSquare(2, 2, 282),
    0x50: this.createSquare(14),
  }
  speedAllowValues: number[] = generateArray(0, 101)
  lightAllowValues: number[] = generateArray(0, 101)
  rate: number[] = [8, 4, 2, 1, 0.5, 0.25, 0.125]
  superResponse: boolean = false
  magneticAxis: boolean = true
  lockWin: boolean = true
}
